import { useState, useEffect, useCallback } from "react";
import api from "api";

export const useStripeData = token => {
  const [users, setUsers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!token) return;

    setLoading(true);
    setError(null);

    try {
      const [usersRes, plansRes, couponsRes] = await Promise.all([
        api.get("/users/all", {
          headers: { Authorization: `Bearer ${token}` }
        }),
        api.get("/v2/stripe/plans", {
          headers: { Authorization: `Bearer ${token}` }
        }),
        api.get("/v2/stripe/coupons", {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      setUsers(usersRes.data);
      setPlans(plansRes.data);
      setCoupons(couponsRes.data.data);
    } catch (err) {
      console.error("Erro ao buscar dados do Stripe:", err);
      setError(
        "Não foi possível carregar os dados. Tente novamente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refreshData = () => {
    fetchData();
  };

  const refreshCoupons = useCallback(async () => {
    try {
      const couponsRes = await api.get("/v2/stripe/coupons", {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCoupons(couponsRes.data.data);
    } catch (error) {
      console.error("Erro ao recarregar cupons", error);
    }
  }, [token]);

  const refreshPlans = useCallback(async () => {
    try {
      const plansRes = await api.get("/v2/stripe/plans", {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPlans(plansRes.data);
    } catch (error) {
      console.error("Erro ao recarregar planos", error);
    }
  }, [token]);

  return {
    users,
    plans,
    coupons,
    loading,
    error,
    refreshData,
    refreshCoupons,
    refreshPlans
  };
};
